// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"4ebc108297dd2c583e00","303":"5b8e2e574062e9799554","495":"51c7b77520b60af7371e"}[chunkId] + ".js";
};